import { c as _c } from "react/compiler-runtime";
import { getSelectedOptionsForVariantSku } from 'components/consumer/PDP/helpers/pdpOptionUtils';
import { useMemo } from 'react';
const usePDPSelectedOptionsFromVariantSku = t0 => {
  const $ = _c(3);
  const {
    productOptions,
    variantSkuOverride
  } = t0;
  let t1;
  bb0: {
    if (!variantSkuOverride || !productOptions) {
      t1 = null;
      break bb0;
    }
    let t2;
    if ($[0] !== productOptions || $[1] !== variantSkuOverride) {
      t2 = getSelectedOptionsForVariantSku(variantSkuOverride, productOptions);
      $[0] = productOptions;
      $[1] = variantSkuOverride;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    const variantSelectedOptions = t2;
    t1 = variantSelectedOptions;
  }
  const selectedOptionsFromVariantSku = t1;
  return selectedOptionsFromVariantSku;
};
export default usePDPSelectedOptionsFromVariantSku;